import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import Button from "./Button";
import Popup from "./Popup";
import PopupContent from "./PopupContent";
import CloseButton from "./CloseButton";
import FaQuestionCircle from "react-icons/lib/fa/question-circle";

export default class FieldMenu extends React.Component {
  state = {};
  handleMenuToggle = () => {
    this.props.handleMenuToggle(this.props.title);
  }

  componentDidMount() {
    this.getStyle();
    window.addEventListener('resize', () => this.getStyle());
    document.addEventListener('scroll', () => this.getStyle());
  }

  getStyle = () => {
    const parent = document.getElementById(this.props.title);
    const rect = parent.getBoundingClientRect();
    this.setState({ parent, rect })
  }



  render() {
    const { open } = this.props;
    let i = 0;
    let products = [];
    let onEvent = this.props.onEvent;

    if(this.props.menuData != null) {
        let data = this.props.menuData;
        products.push(<CloseButton handleCloseButton={this.props.handleCloseButton} />)
        Object.keys(data).forEach( category => {
          products.push(<div className="category"><div><span/>{category}<a className="help-icon" href={`../help/${data[category].help}`} target="_blank" rel="noopener noreferrer"><FaQuestionCircle/></a></div></div>);
          Object.keys(data[category]).forEach(subcategory => {
            let buttons = [];
            Object.keys(data[category][subcategory]).forEach(product => {
              let value = data[category][subcategory][product]["productFile"];
              let unit = data[category][subcategory][product]["units"];
              buttons.push(
                <Button
                    key={i++}
                    label={product}
                    value={value}
                    onEvent={onEvent}
                    unit={unit}
                    onClick={true}
                />
              );
            })
            if(subcategory !== "help") {
              products.push(<div className="trow">
                  <span className="subcat">{subcategory}:</span>{buttons}</div>);
            }
          })
        });
    }
    return (
      <button className={cx("closed-menu", {open})} id={this.props.title} onClick={this.handleMenuToggle}>
        <h3>{this.props.title}</h3>
        {open && (
          <Popup>
            <div className={cx("field-menu", "opened")}>
              <PopupContent top={this.state.rect.top} left={this.state.rect.right+5}> {products} </PopupContent>
            </div>
          </Popup>
        )}
      </button>
    );
  }
}

FieldMenu.propTypes = {
  title: PropTypes.string,
  menuItems: PropTypes.array,
  onEvent: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/FieldMenu.js